export default __webpack_public_path__ + "static/media/wallet.inline.a490230a.svg";